import { Caption1, makeStyles, tokens } from "@fluentui/react-components";
import { useState } from "react";
import { SAMPLE_JOINED_WORKSPACE, SEED_WORKSPACE_META } from "@/engine/workspace-seeds";
import { DEFAULT_TEAM_COLOR, DEFAULT_TEAM_ICON } from "@/features/resources/team-appearance";
import { WorkspaceMark, WorkspaceProfileFields, WorkspaceSwitchRows } from "@/features/workspace/workspace-mark";

const useStyles = makeStyles({
  stack: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  marks: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
  },
  specimen: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "6px",
  },
  note: {
    color: tokens.colorNeutralForeground3,
  },
});

/** 디자인 시스템 「아이콘」 탭. 스위처와 설정이 같은 표식을 쓴다. */
export function WorkspaceMarkSpecimens() {
  const styles = useStyles();
  const growth = SEED_WORKSPACE_META.find((meta) => meta.id === "ws_growth") ?? SEED_WORKSPACE_META[0]!;
  const wavex = SEED_WORKSPACE_META.find((meta) => meta.id === "ws_wavex") ?? SEED_WORKSPACE_META[0]!;
  const [name, setName] = useState("새 워크스페이스");
  const [description, setDescription] = useState("");
  const [icon, setIcon] = useState(DEFAULT_TEAM_ICON);
  const [color, setColor] = useState(DEFAULT_TEAM_COLOR);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  return (
    <div className={styles.stack}>
      <div className={styles.marks}>
        <div className={styles.specimen}>
          <WorkspaceMark icon={growth.icon} color={growth.color} imageUrl={growth.imageUrl} size={20} />
          <Caption1 className={styles.note}>사이드바 · 20px</Caption1>
        </div>
        <div className={styles.specimen}>
          <WorkspaceMark icon={DEFAULT_TEAM_ICON} color={DEFAULT_TEAM_COLOR} imageUrl={null} size={20} />
          <Caption1 className={styles.note}>이미지 없음 · 색 타일</Caption1>
        </div>
        <div className={styles.specimen}>
          <WorkspaceMark icon={wavex.icon} color={wavex.color} imageUrl={wavex.imageUrl} size={20} pending />
          <Caption1 className={styles.note}>받은 초대</Caption1>
        </div>
        <div className={styles.specimen}>
          <WorkspaceMark icon={growth.icon} color={growth.color} imageUrl={growth.imageUrl} size={64} />
          <Caption1 className={styles.note}>설정 · 64px</Caption1>
        </div>
      </div>
      <WorkspaceSwitchRows
        owned={[
          { ...wavex, current: true },
          { ...growth, current: false },
        ]}
        joined={[{ ...SAMPLE_JOINED_WORKSPACE, current: false }]}
      />
      <WorkspaceProfileFields
        name={name}
        description={description}
        icon={icon}
        color={color}
        imageUrl={imageUrl}
        onNameChange={setName}
        onDescriptionChange={setDescription}
        onIconChange={setIcon}
        onColorChange={setColor}
        onImageChange={setImageUrl}
      />
    </div>
  );
}
